import { VERIFY_EMAIL_STATE } from './constants'

const state = {
  [VERIFY_EMAIL_STATE]: {
    bookings: {},
  },
}

export default state
